import { __localesModel, __localizedField } from "@/Utils/locales";
export const models = {
  locales: __localesModel,
  business_id: null
};
export const options = {};

export const Fields = [__localizedField];
